export default __webpack_public_path__ + "static/media/entry.0258952b.webp";